<template>
	<div class="weekly-subscribe">
		<form @submit.prevent="signUp">
			<div class="col-row col-flush">
				<div class="col s12 m8 l8">
					<div class="form-block">
						<label class="form-label required" data-key="email">
							<div class="form-field input">
								<input v-model="model.email" placeholder="Enter your email" type="email" maxlength="64" class="field">
							</div>
						</label>
					</div>
				</div>
				<div class="col s12 m4 l4">
					<div class="submit">
						<button type="submit" class="ui-btn ui-btn-block" :disabled="sending">Subscribe</button>
					</div>
				</div>
			</div>
			<p class="small-print">
				<small>
					By subscribing, you agree to our
					<a :href="`${$app.site_url}/disclaimer.html`">Terms</a>
					and
					<a :href="`${$app.site_url}/privacy.html`">Privacy Policy</a>
				</small>
			</p>
		</form>
	</div>
</template>
<script>
	import {campaignerApi} from '../../api';
	export default {
		data () {
			return {
				sending: false,
				model: {}
			}
		},
		methods: {
			subscribe() {
				let self = this;
				self.sending = true;
				$('span.error').remove();
				campaignerApi.subscribe(self.model).then(response => {
					self.sending = false;
					let res = response.data;
					if(!res.error) {
						self.initModel();
						window.location.href = self.$app.site_url + '/thanks';
					}
				}, (error) => {
					self.sending = false;
					let errors = error.response.data;
					console.log(errors);
					if(errors.errors) {
						Object.entries(errors.errors).forEach((value, index) => {
							$('[data-key="' + value[0] + '"]').append('<span class="error">' + value[1] + '</span>');
						});
					} else {
						alert('Something went wrong, please try again later');
					}
					console.log(error);
				});
			},
			signUp() {
				let self = this;
				self.subscribe();
			},
			initModel() {
				let self = this;
				self.model = {
					email: "",
					subscribe: ['weekly_newsletter']
				}
			},
			initMounted() {
				let self = this;
				self.initModel();
			}
		},
		mounted() {
			let self = this;
			self.initMounted();
		}
	}
</script>